import React from "react"
import { propsToState, reducer } from "./reducer"
import { createActions } from "./actions"

export const SubscriptionContext = React.createContext({
  state: propsToState({}),
  actions: createActions(() => {}, propsToState({})),
})

export const SubscriptionProvider = ({ children, ...props }) => {
  const [state, dispatch] = React.useReducer(reducer, propsToState(props))
  const actions = createActions(dispatch, state)

  return (
    <SubscriptionContext.Provider value={{ state, actions }}>
      {children}
    </SubscriptionContext.Provider>
  )
}